import React from 'react';
import { FoldingCube } from 'better-react-spinkit';

const Loading = () => {
    return (
        <div className="loading fade-in">
            <FoldingCube color="#ccc" size={ 60 } />
        </div>
    );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/app/components/helpers/loading.jsx